<template>
  <Input
    ref="input"
    :class="$style.inputPassword"
    :model="model"
    v-bind="fieldProps"
    @update:model="$emit('update:model', $event)"
  >
    <div
      v-if="isTypePassword"
      :class="[$style.iconWrap, { [$style.passwordHidden]: !isPasswordVisible }]"
      @mousedown.prevent="togglePasswordVisibility"
    >
      <IconView :class="$style.icon" />
    </div>
  </Input>
</template>

<script>
import IconView from '@/components/_icons/IconView.svg'
import Input from './Input.vue'
import { inputProps, methods as fieldMethods } from './field-settings'

const INPUT_TYPE_PASSWORD = 'password'
const INPUT_TYPE_TEXT = 'text'

export default {
  name: 'InputPassword',
  components: {
    Input,
    IconView,
  },

  props: {
    ...inputProps,
  },

  data() {
    return {
      isPasswordVisible: false,
      hasError: false,
    }
  },

  computed: {
    isTypePassword() {
      return !this.type || this.type === INPUT_TYPE_PASSWORD
    },

    fieldProps() {
      return {
        ...this.$props,
        type: !this.isTypePassword
          ? this.type
          : this.isPasswordVisible
            ? INPUT_TYPE_TEXT
            : INPUT_TYPE_PASSWORD,
      }
    },
  },

  methods: {
    ...(() => {
      const methods = {}

      Object.keys(fieldMethods).forEach(methodName => {
        methods[methodName] = function (...args) {
          if (
            methodName in this.$refs.input &&
            typeof this.$refs.input[methodName] === 'function'
          ) {
            // Pass the call to the Input component
            return this.$refs.input[methodName](...args)
          }
        }
      })
      return methods
    })(),

    validate() {
      this.hasError = !this.$refs.input.validate()
    },

    togglePasswordVisibility() {
      this.isPasswordVisible = !this.isPasswordVisible
    },
  },
}
</script>

<style module lang="scss">
@import '@/components/Form/field-settings';

.inputPassword {
  :global {
    .input__field.input__field--text {
      padding-right: 40px;
    }
  }
}

.iconWrap {
  @include fake-padding-link;
  position: absolute;
  top: round($input-height / 2);
  right: 0;
  cursor: pointer;
  transform: translate(-50%, -50%);
  opacity: 0.5;
  transition: opacity 0.1s;
  user-select: none;
  z-index: 10;

  &:hover {
    opacity: 0.8;
  }

  &:after {
    content: '';
    background-color: currentColor;
    position: absolute;
    top: calc(50% + 1px);
    left: 50%;
    transform: translate(-50%, -50%) rotate(45deg);
    transition:
      opacity 0.2s,
      transform 0.2s;
    width: 26px;
    height: 2px;
  }

  &.passwordHidden:after {
    opacity: 0;
    transform: translate(-50%, -50%) rotate(45deg) scale(0);
  }
}

.icon {
  width: 24px;
}
</style>
